export default "__VITE_ASSET__IoOBksO8__"